<template>
  <div>
    <div class="application14">
      <div class="bannerTemp">
        <bannerTemp :data="bannerData"></bannerTemp>
      </div>
      <module1 :data="a"></module1>
      <module1 :data="b"></module1>
      <module1 :data="c" style="margin-bottom:150px;">
        <div slot="content">
          <img src="../../assets/images/application/application14-1.jpg" alt />
          <img src="../../assets/images/application/application14-2.jpg" alt />
          <img src="../../assets/images/application/application14-3.jpg" alt />
          <img src="../../assets/images/application/application14-4.jpg" alt />
        </div>
      </module1>
    </div>
    <div class="mobile-application14">
      <div class="mobile-bannerTemp">
        <bannerTemp :data="bannerData" :isLong="true"></bannerTemp>
      </div>
      <div class="content">
        <div class="range">
          <div class="part-title">
            业务应用范围
          </div>
          <div class="part-content">
            <p>{{ a.p }}</p>
          </div>
        </div>
        <div class="range">
          <div class="part-title">
            业务应用概述
          </div>
          <div class="part-content">
            <p>{{ b.p }}</p>
          </div>
        </div>
        <div class="range">
          <div class="part-title">
            业务应用案例
          </div>
          <el-carousel class="carousel" indicator-position="outside" height="18rem" >
            <el-carousel-item v-for=" index in 4" :key="index">
              <img :src="getImg(`application14-${index}.jpg`)" alt="Carousel Image" style="width: 100%; object-fit: contain;">
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
  </div>
  
</template>

<script>
export default {
  name: "Application14",
  metaInfo: {
    title:
      "安全生产监督管理系统_行业三维可视化应用解决方案-上海臻图信息技术有限公司",
    meta: [
      {
        name: "keywords",
        content: "安全生产管理,安监局安全生产管理,危化品智能管理,安全生产GIS可视化,安全生产BIM渲染"
      },
      {
        name: "description",
        content:
          "基于三维二三维GIS、BIM、GPS、物联网等技术,建立安全生产风险监控预警,对风险点和危险源建立数据库和电子地图,按照“分区域、分级别、网格化”管理来掌握城市风险现状,安全风险分级可视化及监测预警,更好的预防和减少事故灾害的发生。"
      }
    ]
  },
  data() {
    return {
      bannerData: {
        title: "安全生产监督管理系统",
        p:
          "基于三维二三维GIS、BIM、GPS、物联网等技术，建立安全生产风险监控预警，对风险点和危险源建立数据库和电子地图，按照“分区域、分级别、网格化”管理来掌握城市风险现状……"
      },
      a: {
        num: "01",
        name: "业务应用范围",
        p:
          "安监局安全生产管理、城市安全管理、危化品企业和生产管理等安全生产应用。"
      },
      b: {
        num: "02",
        name: "业务应用概述",
        p:
          "基于三维二三维GIS、BIM、GPS、物联网等技术，建立安全生产风险监控预警，对风险点和危险源建立数据库和电子地图，按照“分区域、分级别、网格化”管理来掌握城市风险现状，安全风险分级可视化及监测预警，更好的预防和减少事故灾害的发生。"
      },
      c: {
        num: "03",
        name: "业务应用案例"
      }
    };
  },
  methods: {
    getImg(fileName) {
      return require(`@/assets/images/application/${fileName}`);
    }
  },
  mounted: function() {}
};
</script>

<style lang="less" scoped>
//scoped
.bannerTemp {
  background-image: url("../../assets/images/other/header_bg.jpg");
}
.application14 {
  font-size: 0;
  img {
    width: 584px;
    margin-top: 20px;
    &:nth-child(2n + 1) {
      margin-right: 20px;
    }
  }
}
.mobile-application14 {
  display: none;
  width: 100%;
  flex-direction: column;
  font-family: 'Normal';
  .mobile-bannerTemp {
    width: 100%;
    background-image: url("../../assets/images/other/header_bg.jpg");
    background-position: 30%;
    background-size: cover;
    height: 28rem;
  }
  .content {
    width: 100%;
    font-family: 'Normal';
    .range {
      width: 100%;
      box-sizing: border-box;
      padding: 2rem;
      color: #333333;
      .part-title {
        width: 100%;
        text-align: center;
        font-size: 1.8rem;
        font-weight: bold;
        line-height: 3rem;
      }
      .part-content {
        font-size: 1rem;
        font-weight: 350;
        line-height: 2rem;
        margin-top: 2rem;
        text-indent: 2em;
      }
      .carousel {
        margin-top: 2rem;
      }
    }
  }
}
/deep/.el-carousel__indicators--horizontal  {
  width:100% !important;
  text-align: center !important;
  .is-active {
    .el-carousel__button {
      width: 3rem;
      height: 0.4rem;
      background: #3C80E8;
    }
  }
}
/deep/ .el-carousel__button {
  width: 0.5rem;
  height: 0.4rem;
  background: #C1E1FF;
}
/deep/ .case-carousel {
  .is-active {
    .el-carousel__button {
      width: 3rem;
      height: 0.4rem;
      background: #3C80E8;
    }
  }
}
@media (max-width: 1024px) {
  .application14 {
    display: none !important;
  }
  .bannerTemp {
    display: none !important;
  }
  .mobile-application14 { 
    display: flex !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/application/application14.vue